if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"bday-react": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"ui-alert":1,"ui-share-link-dialog":1,"ui-card-send-control-center-dialog":1,"card-navigation":1,"email-settings":1,"notifications":1,"change-password":1,"payment-info":1,"my-account":1,"cancel":1,"unsubscribe":1,"verify-email":1,"auth-page":1,"card-view":1,"card-sign-edit":1,"card-send-view":1,"cards":1,"my-cards":1,"card-builder":1,"group-cards":1,"card-send-flow":1,"card-read":1,"card-share":1,"card-sign-view":1,"reminders-print-view":1,"card-send-create":1,"contacts-list":1,"holiday-add":1,"holiday-view":1,"my-reminders":1,"calendar":1,"birthday-add":1,"birthday-more":1,"reminder-manual":1,"browse":1,"reminders-landing":1,"homepage":1,"contact-us":1,"happy-birthday":1,"anniversary-gift":1,"popular-name":1,"popular-name-landing":1,"infographic":1,"poply":1,"terms":1,"privacy":1,"about":1,"share-link":1,"testing":1,"ios-app-gift-card-webview":1,"mobile-menu":1,"top-menu":1,"auth-container":1,"birthday-request-landing":1,"birthday-request-save":1,"birthday-request-dead":1,"birthday-request-import":1,"birthday-request-success":1,"birthday-request-help":1,"infographic-card":1,"happy-birthday-card":1,"popular-name-card":1,"card-browser-dialog":1,"card-browser-mobile-filters":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr